import phonesCommitTypes from './commit-types';

const phonesActionsCreators = {
  addPhone() {
    return {
      isAddingPhone: true,
      type: phonesCommitTypes.SET_IS_ADDING_PHONE,
    };
  },
  closeAddPhone() {
    return {
      isAddingPhone: false,
      type: phonesCommitTypes.SET_IS_ADDING_PHONE,
    };
  },
  closeEditPhone() {
    return {
      isEditingPhone: -1,
      type: phonesCommitTypes.SET_IS_EDITING_PHONE,
    };
  },
  editPhone(index) {
    return {
      isEditingPhone: index,
      type: phonesCommitTypes.SET_IS_EDITING_PHONE,
    };
  },
  resetPhoneState() {
    return {
      type: phonesCommitTypes.RESET_PHONE_STATE,
    };
  },
};

export default phonesActionsCreators;
